import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProjectActivityJobQueueView } from "src/components/views/erp/project/activityJobQueue/ProjectActivityJobQueueView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/project/jobQueue")({
	staticData: { title: i18n.t("job_queue"), legacyViewKey: "projectActivityJobQueuePage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ProjectActivityJobQueueView />;
}
